// @core/api/endpoints/booking/join_waitlist.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  JoinWaitlistRequest,
  WaitlistEntryResponse,
} from '../../../types/booking';

const BASE_PATH = '/booking';

/**
 * Join waitlist
 * Adds the customer to the waitlist for a fully-booked resource. When a slot opens, BookingService offers it to the next eligible entry.
 */
export async function JoinWaitlist(
  resource_id: string,
  data: JoinWaitlistRequest,
  options?: RequestOptions
): Promise<WaitlistEntryResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/resources/:resource_id/waitlist`;
  requestPath = requestPath.replace(':resource_id', encodeURIComponent(resource_id));
  const requestOptions = options;
  return client.post<WaitlistEntryResponse>(requestPath, data, requestOptions);
}
